// Etichette condivise dal riepilogo e dalla tabella Stato articoli.
export const STATI = {
  DONE: "Completati", PENDING: "In coda", WAITING: "In attesa",
  REVIEW: "Da rivedere", ERROR: "In errore",
};

export const STATI_IMMAGINI = {
  PENDING: "In coda", SCHEDULED: "Programmato", SUCCESS: "Completato",
  NO_SOURCE: "Nessuna immagine sorgente", ERROR: "In errore", REJECTED: "Rifiutato",
};
